import { defineRouteMetadata } from "@pax/contract-kit";

export { type ContractService, errors, pathFor } from "@pax/contract-kit";

type ContractAuth =
  | { kind: "public"; detail: string }
  /** The browser's sign-in cookie, which the game server has the Product API check. */
  | { kind: "session"; detail: string }
  | {
      kind: "service";
      detail: string;
      caller: "api" | "agent-runner";
      scope: "games:manage" | "game-masters:report";
    }
  | {
      kind: "gameToken";
      detail: string;
      /** The roles whose tokens the route accepts, or every role when left out. */
      roles?: readonly ("player" | "gameMaster" | "grader")[];
      /** Only a token bound to an agent: the game master's, a grader's, or a player agent's. */
      agentsOnly?: true;
    }
  | { kind: "serviceOrGameToken"; detail: string; scope: "games:manage" };

export interface PaxRouteMetadata {
  auth: ContractAuth;
  policy?: {
    session?: true;
  };
}

export const { paxRoute, getPaxRouteMetadata } = defineRouteMetadata<PaxRouteMetadata>();
